module.exports = __webpack_public_path__ + "img/3DScan_6.1bed02ab.png";